import { buildModelManager } from "../builder.js";
const DefaultInstitutionFormSelection = {
  __typename: true,
  id: true,
  cohortType: true,
  createdAt: true,
  createdById: true,
  description: true,
  extractedFields: true,
  formCategory: true,
  formLayout: true,
  institution: true,
  isDefault: true,
  name: true,
  qrCodeToken: true,
  requiresSignature: true,
  scoringRules: true,
  signatureLandscape: true,
  sourceDocument: { url: true, mimeType: true, fileName: true },
  status: true,
  updatedAt: true,
  version: true
};
const modelApiIdentifier = "institutionForm";
const pluralModelApiIdentifier = "institutionForms";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultInstitutionFormSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultInstitutionFormSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionFormSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionFormSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionFormSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionFormSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionFormSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByQrCodeToken",
    findByField: "qrCodeToken",
    findByVariableName: "qrCodeToken",
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionFormSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByQrCodeToken",
    findByField: "qrCodeToken",
    findByVariableName: "qrCodeToken",
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionFormSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createInstitutionForm",
    operationReturnType: "CreateInstitutionForm",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      institutionForm: { required: false, type: "CreateInstitutionFormInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInstitutionFormSelection
  },
  {
    type: "action",
    operationName: "bulkCreateInstitutionForms",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateInstitutionFormsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultInstitutionFormSelection
  },
  {
    type: "action",
    operationName: "updateInstitutionForm",
    operationReturnType: "UpdateInstitutionForm",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      institutionForm: { required: false, type: "UpdateInstitutionFormInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInstitutionFormSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateInstitutionForms",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateInstitutionFormsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultInstitutionFormSelection
  },
  {
    type: "action",
    operationName: "deleteInstitutionForm",
    operationReturnType: "DeleteInstitutionForm",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteInstitutionForms",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertInstitutionForm",
    operationReturnType: "UpsertInstitutionForm",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      institutionForm: { required: false, type: "UpsertInstitutionFormInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateInstitutionFormResult": { hasReturnType: false },
      "... on UpdateInstitutionFormResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInstitutionFormSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertInstitutionForms",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertInstitutionFormsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultInstitutionFormSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "institutionFormGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const InstitutionFormManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultInstitutionFormSelection,
  operations
);
export {
  DefaultInstitutionFormSelection,
  InstitutionFormManager
};
//# sourceMappingURL=InstitutionForm.js.map
